import { Button, EnrollmentHelpText } from '@/shared/components'
import { assetUrl } from '@/shared/utils/assetUrl'
import { ENROLLMENT_SUPPORT_PHONE } from '../../constants/enrollmentContent'
import { StepHeader } from '../StepHeader'

type NotEligibleStepProps = {
  currentStep: number
  totalSteps: number
  onBack: () => void
  onLearnMore: () => void
}

export function NotEligibleStep({
  currentStep,
  totalSteps,
  onBack,
  onLearnMore
}: NotEligibleStepProps) {
  return (
    <div className="bg-white px-4 py-2">
      <div className="mx-auto max-w-4xl animate-fade-in-up">
        <StepHeader currentStep={currentStep} totalSteps={totalSteps} onBack={onBack} />

        <div className="mx-auto max-w-2xl">
          <div className="flex items-start justify-center animate-fade-in-up">
            <h1 className="modal-heading__title text-center">Eligibility Information</h1>
          </div>

          <div className="mx-auto max-w-[42rem] pt-6 flex flex-col gap-4">
            <div
              className="animate-fade-in-up rounded-[8px] bg-white px-4 py-4"
              style={{ animationDelay: '120ms' }}
            >
              <div className="flex items-center gap-3">
                <img
                  src={assetUrl('/assets/icons/x.png')}
                  alt="Not eligible"
                  className="h-12 w-12 shrink-0 object-contain"
                />
                <div>
                  <h2 className="text-lg font-semibold leading-tight text-gray-dark md:text-[20px]">
                    Not Eligible for Online Enrollment
                  </h2>
                  <p className="mt-1 text-sm leading-tight text-gray-dark md:text-[15px]">
                    We couldn't confirm your eligibility based on your answers.
                  </p>
                </div>
              </div>
            </div>

            <div
              className="animate-fade-in-up rounded-[8px] bg-white px-4 py-4"
              style={{ animationDelay: '180ms' }}
            >
              <h3 className="text-sm font-semibold leading-snug text-gray-dark">Reason:</h3>
              <div className="mt-2.5 flex items-center gap-3 text-sm leading-tight text-gray-dark md:text-[15px]">
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary">
                  <img
                    src={assetUrl('/assets/icons/globe.png')}
                    alt="Citizenship"
                    className="h-5 w-5 object-contain"
                  />
                </div>
                <span>Citizenship or residency requirements</span>
              </div>
            </div>

            <div
              className="animate-fade-in-up flex items-center gap-2.5 rounded-lg border border-[#e8dcad] bg-[#fff7df] px-4 py-2.5 text-center text-xs text-gray-dark md:text-[13px]"
              style={{ animationDelay: '240ms' }}
            >
              <img
                src={assetUrl('/assets/icons/light-bulb.png')}
                alt="Options"
                className="h-5 w-5 shrink-0 object-contain"
              />
              <p>
                <span className="font-semibold">You may still have options</span> - our team can
                help.
              </p>
            </div>

            <div
              className="animate-fade-in-up rounded-[8px] border border-[#bfbfbf] bg-white px-5 py-4 text-center"
              style={{ animationDelay: '300ms' }}
            >
              <h4 className="text-lg font-semibold text-gray-dark md:text-[19px]">
                Speak with an Enrollment Specialist
              </h4>
              <p className="mt-1.5 text-base font-semibold text-gray-dark md:text-[18px]">
                Call Us <span className="text-primary">{ENROLLMENT_SUPPORT_PHONE.display}</span>
              </p>
            </div>

            <div className="animate-fade-in-up" style={{ animationDelay: '340ms' }}>
              <Button
                type="button"
                onClick={onLearnMore}
                fullWidth
                className="hover:-translate-y-0.5 active:scale-95"
              >
                Learn More about CDL Training
              </Button>
            </div>

            <div className="text-center animate-fade-in-up" style={{ animationDelay: '420ms' }}>
              <EnrollmentHelpText />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
